export default "__VITE_ASSET__2de8f444__"